import React from 'react';

const ErrorView = () => {
    return (<div className="p-5">Something went wrong, but we were notified.</div>);
}

export default ErrorView;
